import React, { useCallback } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import CameraButton from './CameraButton';
import { useSelfViewContext } from '../../customer-call-sdk';

const StyledSelfViewControl = styled.div`
    display: flex;
    justify-content: center;
    position: absolute;
    left: 50%;
    bottom: 1.5rem;
    transform: translate3d(0, -50%, 0);
    .control-btn {
        cursor: pointer;
        outline: none;
    }

    .control-btn .icon {
        width: 56px;
        height: 56px;
        color: #fff;
    }
    .control-btn.disabled .icon {
        color: rgba(255, 255, 255, 0.3);
    }
`;

const SelfViewControl = () => {
    const { turnedOff, turnOff, turnOn } = useSelfViewContext();

    const handleCameraToggle = useCallback(() => {
        if (turnedOff) {
            turnOn();
        } else {
            turnOff();
        }
    }, [turnedOff]);

    return (
        <StyledSelfViewControl>
            <CameraButton
                className={cx('control-btn')}
                onClick={handleCameraToggle}
                disabled={turnedOff}
            />
        </StyledSelfViewControl>
    );
};

export default SelfViewControl;
